import { api } from './api';

export interface SyncConfigInput {
  endpoint: string;
  auth: {
    type: 'none' | 'bearer' | 'basic' | 'apiKey';
    token?: string;
    username?: string;
    password?: string;
    headerName?: string;
    value?: string;
  };
  syncIntervalMinutes?: number;
  active?: boolean;
}

export const syncConfigService = {
  async get(productId: number) {
    const r = await api.get(`/products/${productId}/client-sync-config`);
    return r.data;
  },
  async upsert(productId: number, data: SyncConfigInput) {
    const r = await api.put(`/products/${productId}/client-sync-config`, data);
    return r.data;
  },
};
